import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

import { Button } from '@/common/components/ui/button';

interface SortButtonProps<TSortField> {
  field: TSortField;
  sortBy: TSortField;
  sortOrder: 'asc' | 'desc';
  onSort: (field: TSortField) => void;
}

export const SortButton = <TSortField,>({
  field,
  sortBy,
  sortOrder,
  onSort,
}: SortButtonProps<TSortField>) => {
  const isSorted = sortBy === field;
  const isAscending = sortOrder === 'asc';

  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-6 w-6 p-0"
      onClick={() => onSort(field)}
    >
      {!isSorted && <ArrowUpDown className="h-3.5 w-3.5" />}
      {isSorted && isAscending && <ArrowUp className="h-3.5 w-3.5" />}
      {isSorted && !isAscending && <ArrowDown className="h-3.5 w-3.5" />}
    </Button>
  );
};
